var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-icon-badge"},[_c('img',{attrs:{"src":_vm.src}}),_vm._v(" "),_c('div',{staticClass:"ellipsis"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }